import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, CardTitle, FormGroup, Input, Label, Row } from 'reactstrap';
import { Button as ButtonMui } from '@material-ui/core';
import { store } from "../../../testStore";

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

/* Result */
import Result from 'iotera-base/result'

/* Json */
import { parse, parseArray, safeDeepGet } from 'iotera-base/json'
import { isEmpty, isNone } from 'iotera-base/object';

/* Routes */
import { domainIsTenant as dit, S } from '../../../routes/routes'

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

/* Sagas Actions */
import { buildWBoundActions } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'

import { SubViewHeaderStep } from '../../../lib/components/subHeader';
import { setDeviceEmpty } from '../../../testActions';
import { CustomTableCell } from '../../../custom/table';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const GEN_TOKEN = 'GEN_TOKEN';
const CHECK_TOKEN = 'CHECK_TOKEN';
const SUBMIT_DEVICE = 'SUBMIT_DEVICE';
const WKEY = "DEVICE_ACTIVATION";
const wBoundActions = buildWBoundActions(WKEY);

const devicesListData = [
  { token: 'uy38d', timestamp: '11:46:55', selected: false },
  { token: 'uy38e', timestamp: '10:40:55', selected: false }]

class DeviceListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data
    };
  }

  handleTrClick = (selectedIndex) => {
    const _this = this
    const _state = _this.state
    let newState = Object.assign({}, _state);
    newState.data.forEach((device, index, devices) => {
      if (index === selectedIndex) {
        devices[index].selected = true
      } else {
        devices[index].selected = false
      }
    })
    _this.setState(newState)
  }

  render() {
    const _this = this
    const _state = _this.state
    let deviceRows = []
    const { data } = _state
    data.forEach((device, index, devices) => {
      deviceRows.push(
        <TableRow>
          <TableCell column="token" data={device.token}></TableCell>
          <TableCell column="timestamp" data={device.timestamp}></TableCell>
          <TableCell column="selector" className="text-center">
            <div><Button color="primary"
              onClick={_this.handleTrClick.bind(_this, index)} outline={!device.selected}>Pilih</Button></div>
          </TableCell>
        </TableRow>)
    })
    return (
      <Table className="table" itemsPerPage={5} pageButtonLimit={5} >
        <TableHead>
          <CustomTableCell column="token"><span>Token</span></CustomTableCell>
          <CustomTableCell column="timestamp"><span>Waktu aktivasi</span></CustomTableCell>
          <CustomTableCell column="selector"><span> </span></CustomTableCell>
        </TableHead>
        {deviceRows}
      </Table>
    )
  }
}

function buildGenConfig(self) {
  const _self = self
  const _props = safeDeepGet(_self, ['props'])
  const domainIsTenant = dit(_props);
  return {
    single_config: {
      [GEN_TOKEN]: {
        wparam: {
          ...domainIsTenant,
          method: "POST",
          path: "/service/web/device/provision/k/gen"
        },
        wcallback: {
          started: function (id) {
          },
          finished: function (id, result) {
            if (result.code === Result.HTTP.OK) {
              const token = result.body.credentials_token;
              _self.setState({ token });
              _props.wSetEnv({
                type: "body",
                env: "token",
                value: { credentials_token: token }
              });
              _props.wSetConfig(buildCheckConfig(_self));
            }
          }
        }
      }
    }
  }
}

function buildCheckConfig(self) {
  const _self = self;
  const _props = safeDeepGet(_self, ['props']);
  const domainIsTenant = dit(_props);
  return {
    single_config: {
      [SUBMIT_DEVICE]: {
        wparam: {
          ...domainIsTenant,
          method: "POST",
          path: "/service/web/device/k/end/add",
          timeout: 180000
        },
        wcallback: {
          started: function (id) {
          },
          finished: function (id, result) {
            if (result.code === Result.HTTP.OK) {
              let action = setDeviceEmpty();
              store.dispatch(action)
              _props.history.push('..' + S + '_device_list_')
              _props.showSingleNotification({ message: "Sukses" });
            } else {
              _props.showSingleNotification({ message: "Gagal" });
            }
            _self.setState({
              loading: false
            })
          }
        }
      }
    },
    background_config: {
      [CHECK_TOKEN]: {
        wparam: {
          ...domainIsTenant,
          method: "POST",
          path: "/service/web/device/provision/k/check"
        },
        wcallback: {
          started: function (id) {
          },
          finished: function (id, result) {
            if (result.code === Result.HTTP.OK) {
              if (result.body.response_result === Result.SUCCESS) {
                _self.setState({ isDisabled: false });
              }
            }
          }
        },
        wenv: { body: "token" }
      }
    }
  }
}

class Example extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      token: '',
      loading: false,
      isDisabled: true
    };
    this.toggle = this.toggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleToken = this.handleToken.bind(this);
    this.canSubmit = this.canSubmit.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    _props.wSetConfig(buildGenConfig(_this));
    // callback global
    setCallbackGlobal(_props)
  }

  componentWillUnmount() {
    const _props = this.props
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  myFunction() {
    let x = document.getElementById("myDIV");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
    let y = document.getElementById("divMy");
    if (y.style.display === "none") {
      y.style.display = "block";
    } else {
      y.style.display = "none";
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let storeValue = store.getState();
    let dataToShow = storeValue;
    let sensors = safeDeepGet(dataToShow, ['device', 'sensors'])
    let sensors_object = parse(sensors);
    if (isNone(sensors_object)) {
      sensors_object = parseArray(sensors);
    }
    let dataToSubmit = {
      ...dataToShow.device,
      sensors: sensors_object,
      credentials_token: _state.token
    }
    _this.setState({
      loading: true
    })
    _props.wSingleRequestCall({
      id: SUBMIT_DEVICE,
      body: dataToSubmit
    });
  }

  canSubmit() {
    this.setState({
      isDisabled: false
    })
  }

  handleToken(event) {
    event.preventDefault();
    this.props.wSingleRequestCall({
      id: GEN_TOKEN
    });
  }

  goBack() {
    this.props.history.push('.' + S + 'sensors')
  };

  render() {
    const _this = this
    const _state = _this.state
    const _props = _this.props
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (isEmpty(dataToShow)) {
      _this.goBack();
    } else {
      if ('device' in dataToShow) {
        if (isEmpty(dataToShow.device)) {
          _this.goBack();
        } else {
          dataToShow = {
            ...dataToShow,
            sensors: parseArray(dataToShow.device.sensors),
          }
        }
      } else {
        _this.goBack();
      }
    }
    const { loading, token, isDisabled } = _state
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#ffffff' />
      </div>
    return (
      <Loader show={loading} message={spinner}>
        <div className="view">
          <SubViewHeaderStep title='Tambah Perangkat' subTitle='Permohonan tambah perangkat baru'
            steps={['Kategori', 'Informasi', 'Konfigurasi', 'Aktivasi']} activeStep={3} />
          <div className="io-container mt-12">
            <form>
              <Row className="centeringItem" style={{ height: 350 }}>
                <div className="col-md-10" id="divMy">
                  <CardTitle className="text-capitalize h6 text-center"><b>Aktivasi perangkat baru</b></CardTitle>
                  <Label className="text-center"
                    style={{ width: '100%', marginBottom: 20 }}>Buka aplikasi Iotera dan masukkan token ini ke device yang muncul di aplikasi
                  </Label>
                  <FormGroup row>
                    <div className="col-md-4 button-right" style={{ marginBottom: 10 }}>
                      <ButtonMui variant="outlined" size="medium" color="primary" onClick={event => _this.handleToken(event)}
                        style={{ marginLeft: 10, minWidth: '0%' }}>Refresh token</ButtonMui>
                    </div>
                    <div className="col-md-8">
                      <Input type="text" value={token} name="token" id="provisioningToken" style={{ height: 40 }} readOnly />
                    </div>
                  </FormGroup>

                  <div style={{ textAlign: 'center', marginTop: 20 }}>
                    {/* TODO SHOW IF HAVE ANY LAST SESSION */}
                    <Button style={{ minWidth: '40%', display: 'none' }} color="info" onClick={_this.myFunction} outline>
                      Lanjutkan Konfigurasi Sebelumnya
                    </Button>
                  </div>
                </div>
                <div className="col-md-12" id="myDIV" style={{ display: "none", marginTop: 50 }}>
                  <CardTitle className="text-capitalize h6 text-center">Lanjutkan aktivasi sebelumnya</CardTitle>
                  <Label>Pilih dari daftar device yang sudah aktif sebelumnya</Label>
                  <DeviceListTable data={devicesListData} />
                  <div style={{ textAlign: 'center', marginTop: 20 }}>
                    <Button color="info" style={{ minWidth: '30%' }} onClick={_this.myFunction} outline>Konfigurasi Ulang</Button>
                  </div>
                </div>
              </Row>
              <hr />
              <div className="button-right" style={{ marginTop: 10 }}>
                <ButtonMui variant="outlined" size="large" style={{ minWidth: '0%' }} onClick={_props.history.goBack} >Kembali</ButtonMui>
                <ButtonMui variant="contained" size="large" disabled={isDisabled} color="primary"
                  onClick={event => _this.handleSubmit(event)} style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</ButtonMui>
              </div>
            </form>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state) {
  return {
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Example));